import React from 'react';
import { FunctionField } from 'react-admin';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';

const RateMarkupField = (props) => {
  return (
    <FunctionField
      render={(fields) => {
        const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({
          location: fields.location,
          settings: fields[props.source],
        });
        if (!props.hasBlendedRateMarkup) {
          return null;
        }
        return rateSettingsDisplayHelper.format12hMarkupDisplay(props.classification);
      }}
      sortBy="blended_rate_markup"
    />
  );
};

RateMarkupField.defaultProps = {
  label: '12h rate active markup',
  source: 'settings',
  classification: 'ten99',
};

export default RateMarkupField;
